<hb-modal-dialog
  [heading]="modalTitle"
  [okDisabled]="!isValid || isReadOnly"
  (okClicked)="okClick()">
  <div content>
    <hb-dynamic-details *ngIf="item" [controls]="controls" [item]="item" (onSaved)="onDialogSaved()" [isReadOnly]="isReadOnly"></hb-dynamic-details>
  </div>
</hb-modal-dialog>
